import styles from "./EarlyAccessToProductLabel.scss";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { getCustomerLoyaltyAccess } from "../../utils/loyalty/getCustomerLoyaltyAccess";
import { getEarlyAccessTranslations } from "../../../common/earlyAccessLabelContent/earlyAccessTranslations";
import classNames from "classnames";
import { useProduct } from "../../context/product/ProductContext";

const EarlyAccessToProductLabel = () => {
  const { getTranslation } = useRuntimeConstants();
  const { product } = useProduct();
  const { customerAccess } = getCustomerLoyaltyAccess(product);
  const textToRender = getEarlyAccessTranslations(getTranslation, customerAccess);

  const accessClass = customerAccess && `access-${customerAccess}`;

  if (!textToRender) {
    return null;
  }

  return (
    <span className={classNames(styles.earlyAccessLabel, styles[accessClass])}>
      {textToRender}
    </span>
  );
};

export default EarlyAccessToProductLabel;
